module.exports = __webpack_public_path__ + "static/media/apartment4.cc84b6c7.jpg";